var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1147 4.66667L5.72418 9.05719C5.20348 9.57789 5.20348 10.4221 5.72418 10.9428C6.24488 11.4635 7.0891 11.4635 7.6098 10.9428L11.8859 6.55228C12.9273 5.51089 12.9273 3.82245 11.8859 2.78105C10.8445 1.73965 9.15611 1.73965 8.11471 2.78105L3.83857 7.17157C2.27647 8.73367 2.27647 11.2663 3.83857 12.8284C5.40066 14.3905 7.93332 14.3905 9.49542 12.8284L13.667 8.66667",
    stroke: "#008080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper-clip.34acf1bfaacff1243401cd34ed1e6aef.svg";
export { ForwardRef as ReactComponent };